// extracted by mini-css-extract-plugin
module.exports = {"root":"CancelPendingInvoice_root__8W1lG"};